module.exports = __webpack_public_path__ + "static/media/logo-gestorando-blanco.6f950761.svg";